import { GoogleMap, withGoogleMap, withScriptjs } from 'react-google-maps'
import { StaticQuery, graphql } from 'gatsby'
import { compose, withProps } from 'recompose'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Img from 'gatsby-image'
import Marker from './marker'
import React from 'react'
import { t } from '@lingui/macro'
import { withI18n } from '@lingui/react'

class Map extends React.Component {
  state = {
    markers: null,
  }

  componentDidMount() {
    this.setState({
      markers: [
        {
          defaultCenter: true,
          navigateLink: 'https://goo.gl/maps/fCoQWYAc32PjA3Jv8',
          position: {
            lat: 50.0919714,
            lng: 14.4578891,
          },
          title: 'Klika Dent'.toUpperCase(),
          type: 'KLIKA_DENT',
        },
        {
          navigateLink: 'https://goo.gl/maps/dYDm5DekvdFyDfhaA',
          position: {
            lat: 50.0934976,
            lng: 14.4517546,
          },
          title: this.props.i18n._(t`Křižíkova (metro)`),
          type: 'PUBLIC_TRANSPORT',
        },
        {
          navigateLink: 'https://goo.gl/maps/F1RNXtED87ToYucAA',
          position: {
            lat: 50.09518,
            lng: 14.45638,
          },
          title: this.props.i18n._(t`Urxova (tramvaj, bus)`),
          type: 'PUBLIC_TRANSPORT',
        },
      ],
    })
  }

  render() {
    if (!this.state.markers) {
      return false
    }

    return (
      <StaticQuery
        query={graphql`
          {
            logoTooth: file(relativePath: { eq: "images/logo-icon.png" }) {
              childImageSharp {
                fixed(width: 17, height: 17) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        `}
        render={({ logoTooth }) => {
          return (
            <GoogleMap
              defaultCenter={
                this.state.markers.find(({ defaultCenter }) => defaultCenter)
                  .position
              }
              defaultZoom={16}
            >
              {this.state.markers.map(({ type, ...otherProps }) => {
                let icon

                switch (type) {
                  case 'PARKING':
                    icon = <FontAwesomeIcon icon="parking" size="lg" />
                    break

                  case 'PUBLIC_TRANSPORT':
                    icon = <FontAwesomeIcon icon="bus" size="lg" />
                    break

                  case 'KLIKA_DENT':
                    icon = (
                      <Img
                        fixed={logoTooth.childImageSharp.fixed}
                        imgStyle={{ margin: 0 }}
                        style={{ verticalAlign: 'sub' }}
                      />
                    )

                    break

                  default:
                }

                return <Marker icon={icon} {...otherProps} />
              })}
            </GoogleMap>
          )
        }}
      />
    )
  }
}

export default compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${
      process.env.GATSBY_GOOGLE_MAPS_API_KEY
    }&libraries=drawing`,
    loadingElement: <div style={{ height: '100%' }} />,
    mapElement: <div style={{ height: '100%' }} />,
  }),
  withScriptjs,
  withGoogleMap,
  withI18n()
)(Map)
